/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';
import { EliminarCompany, ObtenerCompanies } from "../../../Service/Service.compania";
import CompanyCreate from "./CompanyCreate";
import usePermissions from "../../../hook/usePermissions";
import useListaLocal from "../../../hook/useListaLocal";
import DataTable from "../../UI/DataTable/DataTable";
import { Celda, CeldaDoble } from "../../UI/DataTable/piezas";
import MenuAcciones from "../../UI/MenuAcciones";
import Boton from "../../UI/Boton";
import Modal, { ResumenConsecuencias } from "../../UI/Modal/Modal";
import { useToast } from "../../UI/Aviso";
import { CampoTexto } from "../../UI/Campo";
import { IconoMas, IconoEditar, IconoEliminar, IconoBuscar } from "../../UI/Iconos";

export default function Company({tabs}) {
  // RBAC-CUTOVER-01: la accion "Crear Company" depende del permiso RBAC
  // real (backend: RequirePermission("company.create")), nunca de
  // nivel_user_id/isDoctor/role===.
  // RBAC-CUTOVER-07: Editar/Eliminar ahora dependen de company.edit/
  // company.delete respectivamente (backend ya los exige en
  // company.routes.ts).
  const { hasPermission } = usePermissions();
  const [show, setShow] = useState(false);
  const [editarCompany, setEditCompany] = useState(null)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [ping, setPing] = useState(false)
  const [listCompany, setListCompany] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [porBorrar, setPorBorrar] = useState(null)
  const [borrando, setBorrando] = useState(false)
  const { mostrar } = useToast();
  // Buscar y paginar sobre lo que ya llegó: `api/company` devuelve la lista
  // entera y no acepta ni búsqueda ni página.
  const lista = useListaLocal(listCompany, { campos: ["company", "email", "direccion"] });

  useEffect(() => {
      (async()=>{
        setLoading(true)
        const response = await ObtenerCompanies()
        if(response){
            setListCompany(response)
            setError(null)
        } else {
            // Antes, un fallo dejaba `loading` en true PARA SIEMPRE: la pantalla
            // se quedaba con el spinner girando y sin decir nada. El servicio
            // devuelve `null` sin el motivo del servidor, así que aquí no se
            // puede decir más que esto.
            setListCompany([])
            setError("No se pudo obtener el listado de compañías.")
        }
        setLoading(false)
      })()

  }, [ping, tabs.company])

  useEffect(() => {
    if(show === false){
      setEditCompany(null)
    }
  }, [show])

  const EdidarCompania = (company) => {
    setEditCompany(company)
    handleShow()
  }

  const DeleteComapany = async(idcompany) => {
    setBorrando(true)
    const response = await EliminarCompany(idcompany)
    setBorrando(false)
    setPorBorrar(null)
    if(response){
      mostrar({ tipo: "exito", texto: "Compañía eliminada." })
      setPing(!ping)
    } else {
      // Antes esto no decía absolutamente nada: se pulsaba Eliminar, la fila
      // seguía ahí y no había forma de saber si había fallado.
      mostrar({ tipo: "error", texto: "No se pudo eliminar la compañía." })
    }
  }

  const columnas = [
    {
      key: "company",
      titulo: "Compañía",
      render: (c) => <CeldaDoble principal={c.company} secundario={c.direccion} />,
    },
    { key: "email", titulo: "Email", ancho: 240, render: (c) => <Celda valor={c.email} /> },
    {
      key: "cant_clinicas",
      titulo: "Clínicas",
      ancho: 100,
      alinear: "derecha",
      render: (c) => <Celda valor={c.cant_clinicas} mono />,
    },
    {
      // Los dos recuentos de personas se leen juntos: dicen el tamaño de la
      // compañía, que es lo mismo que dice el de clínicas.
      key: "personas",
      titulo: "Personas",
      ancho: 210,
      render: (c) => <Celda valor={`${c.cant_doctores} doctores · ${c.cant_administrativo} administrativos`} />,
    },
    {
      key: "acciones",
      titulo: "",
      ancho: 60,
      alinear: "centro",
      render: (c) => {
        const acciones = [];
        if (hasPermission("company.edit")) {
          acciones.push({ label: "Editar", icono: IconoEditar, onClick: () => EdidarCompania(c) });
        }
        if (hasPermission("company.delete")) {
          acciones.push({ label: "Eliminar", icono: IconoEliminar, peligro: true, onClick: () => setPorBorrar(c) });
        }
        return acciones.length > 0 ? <MenuAcciones acciones={acciones} titulo={`Acciones de ${c.company}`} /> : null;
      },
    },
  ];

  return (
    <section>
      {hasPermission("company.create") && (
        <div className="d-flex justify-content-end mb-3">
          <Boton variante="primario" icono={IconoMas} onClick={handleShow} data-testid="company-crear">
            Crear Company
          </Boton>
        </div>
      )}

      <div className="mb-3" style={{ maxWidth: 380 }}>
        <CampoTexto
          etiqueta="Buscar compañía"
          icono={IconoBuscar}
          placeholder="Nombre, email o dirección"
          value={lista.texto}
          onChange={(e) => lista.setTexto(e.target.value)}
          data-testid="company-buscar"
        />
      </div>

      <DataTable
        columnas={columnas}
        filas={lista.visibles}
        filaKey="idcompany"
        cargando={loading}
        error={error}
        onReintentar={() => setPing(!ping)}
        etiquetaTabla="Compañías"
        hayFiltrosAplicados={lista.hayBusqueda}
        onLimpiarFiltros={lista.limpiar}
        textoVacioSinFiltros="Todavía no hay ninguna compañía registrada."
        paginacion={lista.paginacion}
      />

      {/* Eliminar una compañía NO pedía confirmación: un clic en un menú y la
          compañía se iba, con sus clínicas y su gente detrás. Ahora se dice
          exactamente qué se está borrando antes de borrarlo. */}
      <Modal
        abierto={Boolean(porBorrar)}
        titulo="Eliminar compañía"
        destructivo
        onCerrar={() => setPorBorrar(null)}
        secundario={{ label: "Cancelar" }}
        primario={{
          label: "Eliminar",
          cargando: borrando,
          onClick: () => DeleteComapany(porBorrar.idcompany),
        }}
      >
        <p>Vas a eliminar <b>{porBorrar?.company}</b>. Esta acción no se puede deshacer.</p>
        <ResumenConsecuencias
          filas={[
            { etiqueta: "Clínicas asociadas", valor: porBorrar?.cant_clinicas, tono: "aviso" },
            { etiqueta: "Doctores", valor: porBorrar?.cant_doctores, tono: "aviso" },
            { etiqueta: "Administrativos", valor: porBorrar?.cant_administrativo, tono: "aviso" },
          ]}
        />
      </Modal>

      <Offcanvas style={{ width: '50%' }} placement="end" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Creación Company
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <CompanyCreate
            setPing={setPing}
            setShow={setShow}
            editarCompany={editarCompany}
          />
        </Offcanvas.Body>
      </Offcanvas>

    </section>
  );
}
